import React from 'react'
import HeaderInfo from './headerInfo'
import { InvoiceForm } from './invoiceForm'
import ErrorMessagesWindow from '@commonComponents/errorValidationWindow';
import { useSelector } from 'react-redux';

export const  ItemForm =(props)=>{

  const ErrorWarningsList = useSelector((state) => state.ErrorValidationReducer?.itemsTab) || []

  return (
    <div className="formContentareaC88" style={{ height: 'calc(100vh - 329px)' }}>
      {!props?.isServerErrorsCommon && ErrorWarningsList?.length > 0 && !props.disabled && (
            <ErrorMessagesWindow errors={ErrorWarningsList} />
          )}
       <HeaderInfo />
       <InvoiceForm />
    </div>
  )
}

export default ItemForm
